import SidebarBookingsAiController from 'uplisting-frontend/pods/-sidebar/bookings/ai/controller';

export default class ProtectionOverviewBookingsAiController extends SidebarBookingsAiController {}
